"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverPreferencesSchema = exports.SaveDriverPreferencesRequestSchema = exports.DriverPreferenceCategory = exports.RecoveryOptionSchema = exports.RecoveryOption = exports.AmenityOptionSchema = exports.AmenityOption = exports.SpotTypeSchema = exports.SpotType = void 0;
const zod_1 = require("zod");
/**
 * Type of parking stall a driver prefers. Field values are shared with
 * `apps/mobile/src/config/driverPreferences.ts`.
 */
var SpotType;
(function (SpotType) {
    SpotType["HighwayRestArea"] = "highwayRestArea";
    SpotType["TruckStop"] = "truckStop";
    SpotType["SecuredParking"] = "securedParking";
    SpotType["SimpleParking"] = "simpleParking";
    SpotType["IndustrialArea"] = "industrialArea";
    SpotType["AtCustomer"] = "atCustomer";
})(SpotType || (exports.SpotType = SpotType = {}));
exports.SpotTypeSchema = zod_1.z.nativeEnum(SpotType);
/** Additional parking amenities a driver marked as important. */
var AmenityOption;
(function (AmenityOption) {
    AmenityOption["Toilet"] = "hasToilet";
    AmenityOption["Shower"] = "hasShower";
    AmenityOption["Restaurant"] = "hasRestaurant";
    AmenityOption["GasStation"] = "hasGasStation";
    AmenityOption["Shop"] = "hasShop";
    AmenityOption["Wifi"] = "hasWifi";
    AmenityOption["FreeOfCharge"] = "freeOfCharge";
    AmenityOption["Reservable"] = "isReservable";
    AmenityOption["ManySpacesAvailable"] = "manySpacesAvailable";
})(AmenityOption || (exports.AmenityOption = AmenityOption = {}));
exports.AmenityOptionSchema = zod_1.z.nativeEnum(AmenityOption);
/** What helps a driver recover during a break. No rest-area attribute mapping exists yet — demand-side only. */
var RecoveryOption;
(function (RecoveryOption) {
    RecoveryOption["QuietLocation"] = "quietLocation";
    RecoveryOption["WellLit"] = "wellLit";
    RecoveryOption["GreenSpaceNearby"] = "greenSpaceNearby";
    RecoveryOption["HealthyFood"] = "healthyFood";
    RecoveryOption["CleanSanitary"] = "cleanSanitary";
    RecoveryOption["ShadeInSummer"] = "shadeInSummer";
})(RecoveryOption || (exports.RecoveryOption = RecoveryOption = {}));
exports.RecoveryOptionSchema = zod_1.z.nativeEnum(RecoveryOption);
/**
 * Backend storage groups selections into rows keyed by this category tag
 * (one row per `(userId, category, optionKey)`), so new categories/options
 * can be added later without a schema migration.
 */
var DriverPreferenceCategory;
(function (DriverPreferenceCategory) {
    DriverPreferenceCategory["SpotType"] = "spot_type";
    DriverPreferenceCategory["Amenities"] = "amenities";
    DriverPreferenceCategory["Recovery"] = "recovery";
})(DriverPreferenceCategory || (exports.DriverPreferenceCategory = DriverPreferenceCategory = {}));
function uniqueArray(schema) {
    return zod_1.z.array(schema).refine((values) => new Set(values).size === values.length, {
        message: 'Duplicate values are not allowed',
    });
}
// Schema-first: types are `z.infer`-derived below, not hand-written interfaces checked
// against the schema. An explicit `z.ZodType<T>` annotation here (see organization.ts for
// the same pattern) type-checks under this package's own build but fails under the TS
// version apps/routing-functions' test runner resolves for this same source file via its
// jest moduleNameMapper — verified empirically. Schema-first avoids the mismatch and keeps
// a single source of truth.
exports.SaveDriverPreferencesRequestSchema = zod_1.z.object({
    spotTypes: uniqueArray(exports.SpotTypeSchema),
    amenities: uniqueArray(exports.AmenityOptionSchema),
    recovery: uniqueArray(exports.RecoveryOptionSchema),
});
exports.DriverPreferencesSchema = exports.SaveDriverPreferencesRequestSchema.extend({
    userId: zod_1.z.string(),
    /** ISO 8601 timestamp of the most recent save. Absent if never saved. */
    updatedAt: zod_1.z.string().optional(),
});
//# sourceMappingURL=driver-preferences.js.map